import { createSelector } from 'reselect';
import { reduxKey } from '../../constants';
export const getAllModules = (state)=>{
    var _state_reduxKey;
    return (_state_reduxKey = state[reduxKey]) === null || _state_reduxKey === void 0 ? void 0 : _state_reduxKey.modules;
};
export const getAllModuleIds = createSelector(getAllModules, (modules)=>Object.values(modules || {}).map((m)=>m.id));
export const getModule = (state, moduleId)=>{
    var _getAllModules;
    return (_getAllModules = getAllModules(state)) === null || _getAllModules === void 0 ? void 0 : _getAllModules[moduleId];
};
export const getModuleData = createSelector(getModule, (m)=>{
    if (!m) {
        return {};
    }
    const { moduleData } = m;
    const { dataKey = '' } = moduleData;
    return moduleData[dataKey] || {};
});
export const getModuleMeta = createSelector(getModule, (m)=>{
    var _m;
    return (_m = m) === null || _m === void 0 ? void 0 : _m.moduleMeta;
});
export const getModuleName = createSelector(getModule, (m)=>{
    var _m;
    return (_m = m) === null || _m === void 0 ? void 0 : _m.name;
});
export const getModulePrivs = createSelector(getModule, (m)=>{
    var _m;
    return (_m = m) === null || _m === void 0 ? void 0 : _m.privileges;
});
export const getModuleVersion = createSelector(getModule, (m)=>{
    var _m;
    return (_m = m) === null || _m === void 0 ? void 0 : _m.version;
});
export const getModuleRequests = createSelector(getModule, (m)=>{
    var _m;
    return (_m = m) === null || _m === void 0 ? void 0 : _m.requests;
});
export const getModuleRequestsPath = (state, moduleId, path)=>{
    var _getModuleRequests;
    return (_getModuleRequests = getModuleRequests(state, moduleId)) === null || _getModuleRequests === void 0 ? void 0 : _getModuleRequests[path];
};
export const getAllModulesByModuleType = createSelector(getAllModules, (_, moduleName)=>moduleName, (modules, moduleName)=>{
    var _Object_values;
    return (_Object_values = Object.values(modules)) === null || _Object_values === void 0 ? void 0 : _Object_values.filter((m)=>m.name === moduleName);
});
export const getModuleByModuleType = createSelector(getAllModulesByModuleType, (modules)=>modules.pop());
export const getModuleDataByModuleType = createSelector(getModuleByModuleType, (module)=>{
    var _module;
    return (_module = module) === null || _module === void 0 ? void 0 : _module.moduleData;
});
export const getModuleIdByModuleType = createSelector(getModuleByModuleType, (module)=>{
    var _module;
    return (_module = module) === null || _module === void 0 ? void 0 : _module.id;
});
export const canEditModule = createSelector(getModule, (m)=>{
    var _m_privileges, _m;
    return ((_m = m) === null || _m === void 0 ? void 0 : (_m_privileges = _m.privileges) === null || _m_privileges === void 0 ? void 0 : _m_privileges.edit) === true;
});
export const canDeleteModule = createSelector(getModule, (m)=>{
    var _m_privileges, _m;
    return ((_m = m) === null || _m === void 0 ? void 0 : (_m_privileges = _m.privileges) === null || _m_privileges === void 0 ? void 0 : _m_privileges.delete) === true;
});
